import { Anchor, Container, Loader, Table, Text } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'

import { NavAnchor } from '#components/NavAnchor'
import { useMst } from '#state'

import { Breadcrumbs } from '../Breadcrumbs'
import { stripeCustomerUrl } from '../helpers'

export const Accounts = () => {
  const { scrapi, environment } = useMst()

  const accountsQuery = useQuery({
    queryKey: ['staff.accounts'],
    queryFn: async () => {
      const result = await scrapi.staff.accounts()
      if (result.status !== 200) {
        throw new Error('Error fetching accounts', { cause: result })
      }
      return result.body.accounts
    },
  })

  return (
    <Container>
      <Breadcrumbs />
      <h1>Accounts</h1>
      {accountsQuery.isPending ? <Loader size="sm" /> : null}
      {accountsQuery.isError ? (
        <Text c="dimmed">Couldn&rsquo;t load accounts</Text>
      ) : null}
      {accountsQuery.isSuccess ? (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Owner</Table.Th>
              <Table.Th>Stripe customer</Table.Th>
              <Table.Th>Workspaces</Table.Th>
              <Table.Th>Seats</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {accountsQuery.data.map((account) => (
              <Table.Tr key={account.ownerId}>
                <Table.Td>
                  <NavAnchor href={`/users/${account.ownerId}`}>
                    {account.ownerName}
                  </NavAnchor>
                  <Text size="sm" c="dimmed">
                    {account.ownerEmail}
                  </Text>
                </Table.Td>
                <Table.Td>
                  {account.stripeCustomerId ? (
                    <Anchor
                      href={stripeCustomerUrl(
                        environment.config,
                        account.stripeCustomerId,
                      )}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {account.stripeCustomerId}
                    </Anchor>
                  ) : (
                    <Text c="dimmed">none</Text>
                  )}
                </Table.Td>
                <Table.Td>{account.workspaceCount}</Table.Td>
                <Table.Td>{account.seatHolderCount}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : null}
    </Container>
  )
}
